export default __webpack_public_path__ + "static/backgroundPublisher-b97ec854af2b520f20dd5bec8b6627e7.jpg";